module.exports = __webpack_public_path__ + "img/ic-plus.8af6f682.svg";